import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";

const cardStyle = {
  bgcolor: "#fff",
  color: "#4f4f4f",
};

const objectList = [
  {
    category: "THE HUB",
    title: "Training Institute",
    subtitle:
      " Aquatic Hub Afrique Network Limited offers several courses targeted towards multiple value chains of the Aquaculture and Fisheries industry in Nigeria and across Africa.",
    link: "/our-services/training-institute",
  },
  {
    category: "COMMERCIAL CENTER",
    title: "Farm Services",
    subtitle:
      " Fish Shoal Nigeria serves as the commercial arm of our organization, currently focused on establishing marketing linkages and facilitating offtake arrangements.",
    link: "/our-services/farm-services",
  },

  {
    category: "INNOVATION",
    title: "Technical Dept.",
    subtitle:
      "The Technical Department of Aquatic Hub Afrique Network Limited designs, constructs, and fabricates fish gears and equipment needed across multiple value chains of the Aquaculture and Fisheries Sector.",
    link: "/our-services/technical-department",
  },
  {
    category: "EXPERIENCE",
    title: "AHAN Consulting",
    subtitle:
      "AHAN's consulting team comprises faculty and experts with over 30 years of experience in delivering comprehensive consulting services aimed at enhancing sustainable fisheries and aquaculture throughout Nigeria and Africa.",
    link: "/our-services/ahan-consulting",
  },
];
const Intro = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "10% 0%" }}>
      <Typography
        variant={"body1"}
        fontWeight={700}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"1%"}
      >
        Addressing the production of good quality fish in Nigeria.
      </Typography>
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#00AEEF"}
        paddingBottom={"1%"}
      >
        <Typography
          component={"span"}
          variant={"h3"}
          color="#3E4095"
          fontWeight={900}
        >
          Our {""}
        </Typography>
        Services
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { category, title, link, subtitle } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                marginTop={{ xs: "15%", sm: "3%" }}
              >
                <Box
                  component={Card}
                  height={"100%"}
                  padding={"5% 6%"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  margin={{ xs: "4% 0%", sm: "2% 0%" }}
                  data-aos={"fade-down"}
                  sx={{ ...cardStyle }}
                >
                  <Typography
                    variant={"subtitle2"}
                    fontWeight={900}
                    paddingTop={"6%"}
                  >
                    {category}
                  </Typography>
                  <Typography
                    variant={"h4"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#3E4095"}
                  >
                    {title}
                  </Typography>
                  <Typography variant={"body1"} paddingTop={"6%"}>
                    {subtitle}
                  </Typography>
                  <Grid item xs={12} marginTop={{ xs: "0%", sm: "4%" }}>
                    <Divider color={"#fff"} />
                  </Grid>
                  <Box marginLeft={{ xs: " 0%", sm: "0%" }} paddingTop={"2%"}>
                    <Link
                      underline="none"
                      component="a"
                      href={link}
                      textAlign={"left"}
                      color="#00AEEF"
                      fontWeight={700}
                      sx={{
                        "&:hover": {
                          color: "#3E4095",
                        },
                      }}
                    >
                      Read More &#10141;
                    </Link>
                  </Box>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Intro;
